import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const ListCourse = createAsyncThunk('course-list', (params: {}, thunkAPI) =>
  handleRequest(axios.get('/api/course/list', params), thunkAPI)
)

export const createCourse = createAsyncThunk('course-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/course/store', data), thunkAPI)
)

export const editCourse = createAsyncThunk('course-edit', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course/edit/${id}`), thunkAPI)
)

export const deleteCourse = createAsyncThunk('course-delete', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course/destroy/${id}`), thunkAPI)
)

export const viewCourse = createAsyncThunk('course-view', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course/view/${id}`), thunkAPI)
)

export const listCourseLessons = createAsyncThunk('course-lessons', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course-lesson/list/${id}`), thunkAPI)
)

export const listCourseSessionLessons = createAsyncThunk(
  'course-lesson-session',
  ({id, lesson_number}: {id: string; lesson_number: number}, thunkAPI) =>
    handleRequest(axios.get(`/api/course-lesson/list-by-lesson/${id}/${lesson_number}`), thunkAPI)
)

export const createCourseLesson = createAsyncThunk('course-lesson-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/course-lesson/store', data), thunkAPI)
)

export const deleteCourseLesson = createAsyncThunk('course-lesson-delete', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course-lesson/destroy/${id}`), thunkAPI)
)

export const editCourseLesson = createAsyncThunk('course-lesson-edit', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course-lesson/edit/${id}`), thunkAPI)
)

export const toggleCourseLesson = createAsyncThunk('course-lesson-toggle', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course-lesson/toggle-visibility/${id}`), thunkAPI)
)

export const ListPublicationCategory = createAsyncThunk('pub-categories', (params: {}, thunkAPI) =>
  handleRequest(axios.get('/api/publication-category/list', params), thunkAPI)
)

export const createPublicationCategory = createAsyncThunk(
  'pub-category-create',
  (data: {}, thunkAPI) =>
    handleRequest(axios.post('/api/publication-category/store', data), thunkAPI)
)

export const editPublicationCategory = createAsyncThunk(
  'pub-category-edit',
  (id: string, thunkAPI) =>
    handleRequest(axios.get(`/api/publication-category/edit/${id}`), thunkAPI)
)

export const deletePublicationCategory = createAsyncThunk(
  'pub-category-delete',
  (id: string, thunkAPI) =>
    handleRequest(axios.get(`/api/publication-category/destroy/${id}`), thunkAPI)
)

export const ListPublicationField = createAsyncThunk('pub-field-list', (params: {}, thunkAPI) =>
  handleRequest(axios.get('/api/publication-field/list', params), thunkAPI)
)

export const createPublicationField = createAsyncThunk('pub-field-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/publication-field/store', data), thunkAPI)
)

export const editPublicationField = createAsyncThunk('pub-field-edit', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/publication-field/edit/${id}`), thunkAPI)
)

export const deletePublicationField = createAsyncThunk('pub-field-delete', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/publication-field/destroy/${id}`), thunkAPI)
)

export const ListPublication = createAsyncThunk('pub-list', (params: {}, thunkAPI) =>
  handleRequest(axios.get('/api/publication/list', params), thunkAPI)
)

export const createPublication = createAsyncThunk('publication-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/publication/store', data), thunkAPI)
)

export const editPublication = createAsyncThunk('publication-edit', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/publication/edit/${id}`), thunkAPI)
)

export const deletePublication = createAsyncThunk('publication-delete', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/publication/destroy/${id}`), thunkAPI)
)

export const getAuthors = createAsyncThunk('get-authors', (type: string, thunkAPI) =>
  handleRequest(axios.get(`/api/publication/get-author/${type}`), thunkAPI)
)

export const togglePublication = createAsyncThunk('publication-toggle', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/publication/toggle/${id}`), thunkAPI)
)

// rate Publication
export const ratePublication = createAsyncThunk<
  any,
  {id: string; rate: string},
  {rejectValue: {errors: string[]}}
>('publication-rating', async ({id, rate}, thunkAPI) => {
  try {
    const res = await axios.get(`/api/publication/rating/${id}/${rate}`)
    return res.data
  } catch (error: any) {
    if (error.response && error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListVideoLibrary = createAsyncThunk('video-libraries', (params: {}, thunkAPI) =>
  handleRequest(axios.get('/api/video-library/list', params), thunkAPI)
)

export const createVideoLibrary = createAsyncThunk('video-library-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/video-library/store', data), thunkAPI)
)

export const editVideoLibrary = createAsyncThunk('video-library-edit', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/video-library/edit/${id}`), thunkAPI)
)

export const deleteVideoLibrary = createAsyncThunk('video-library-delete', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/video-library/destroy/${id}`), thunkAPI)
)

export const toggleVideoLibrary = createAsyncThunk('video-library-toggle', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/video-library/toggle/${id}`), thunkAPI)
)

export const emailToRelatedStudents = createAsyncThunk('email-to-students', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/campus-faculty/email', data), thunkAPI)
)

export const ListTimeTable = createAsyncThunk('timetable-list', (lang: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/list/${lang}`), thunkAPI)
)

export const deleteTimeTableCourse = createAsyncThunk(
  'timetable-course-delete',
  (id: string, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/destroy-course/${id}`), thunkAPI)
)

export const createTimeTableCourse = createAsyncThunk(
  'timetable-course-create',
  (data: {}, thunkAPI) => handleRequest(axios.post('/api/timetable/store-course', data), thunkAPI)
)

export const editTimeTableCourse = createAsyncThunk(
  'timetable-course-edit',
  (id: string, thunkAPI) => handleRequest(axios.get(`/api/timetable/edit-course/${id}`), thunkAPI)
)

export const deleteTimeTableProgram = createAsyncThunk(
  'timetable-program-delete',
  (id: string, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/destroy-program/${id}`), thunkAPI)
)

export const createTimeTableProgram = createAsyncThunk(
  'timetable-program-create',
  (data: {}, thunkAPI) => handleRequest(axios.post('/api/timetable/store-program', data), thunkAPI)
)

export const editTimeTableProgram = createAsyncThunk(
  'timetable-program-edit',
  (id: string, thunkAPI) => handleRequest(axios.get(`/api/timetable/edit-program/${id}`), thunkAPI)
)

export const deleteTimeTableSemester = createAsyncThunk(
  'timetable-semester-delete',
  (id: string, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/destroy-semester/${id}`), thunkAPI)
)

export const createTimeTableSemester = createAsyncThunk(
  'timetable-semester-create',
  (data: {}, thunkAPI) => handleRequest(axios.post('/api/timetable/store-semester', data), thunkAPI)
)

export const editTimeTableSemester = createAsyncThunk(
  'timetable-semester-edit',
  (id: string, thunkAPI) => handleRequest(axios.get(`/api/timetable/edit-semester/${id}`), thunkAPI)
)

export const deleteTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-delete',
  (id: string, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/destroy-schedule/${id}`), thunkAPI)
)

export const createTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-create',
  (data: {}, thunkAPI) => handleRequest(axios.post('/api/timetable/store-schedule', data), thunkAPI)
)

export const editTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-edit',
  (id: string, thunkAPI) => handleRequest(axios.get(`/api/timetable/edit-schedule/${id}`), thunkAPI)
)

export const toggleCourse = createAsyncThunk('course-toggle', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/toggle/${id}`), thunkAPI)
)

export const toggleProgram = createAsyncThunk('program-toggle', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/program-toggle/${id}`), thunkAPI)
)

export const AddStudentToCourse = createAsyncThunk('add-student', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/timetable/add-student', data), thunkAPI)
)

export const ListCourseStudents = createAsyncThunk(
  'course-students',
  ({target_type, target_id}: {target_type: string; target_id: string}, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/stduents-list/${target_type}/${target_id}`), thunkAPI)
)

export const deleteStudentCourse = createAsyncThunk(
  'student-course-delete',
  (id: string, thunkAPI) => handleRequest(axios.get(`/api/timetable/destroy/${id}`), thunkAPI)
)

export const CourseStudentsDelete = createAsyncThunk(
  'students-course-delete',
  (data: {}, thunkAPI) =>
    handleRequest(axios.post(`/api/timetable/destroy-course-students`, data), thunkAPI)
)

export const GetLecturers = createAsyncThunk('get-lecturers', (_, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/get-lecturers`), thunkAPI)
)

export const TimeTablePrint = createAsyncThunk('timetable-print', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/print/${id}`), thunkAPI)
)

export const ApproveStudentScore = createAsyncThunk(
  'approve-students-score',
  ({target_id, target_type}: {target_id: string; target_type: string}, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/approve-score/${target_id}/${target_type}`), thunkAPI)
)

export const PrintStdAttendance = createAsyncThunk(
  'student-att-print',
  ({courseId, type}: {courseId: string; type: string}, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/att-print/${courseId}/${type}`), thunkAPI)
)

export const PrintExamTimeTable = createAsyncThunk('exam-timetable', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/exam-timetable/${id}`), thunkAPI)
)

export const PrintStudentSignatures = createAsyncThunk('exam-timetable', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/students-signature/${id}`), thunkAPI)
)

export const CourseEvReport = createAsyncThunk(
  'course-ev-report',
  ({tarId, tarType}: {tarId: string; tarType: string}, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/course-ev-report/${tarId}/${tarType}`), thunkAPI)
)

export const PrintCourseEvReport = createAsyncThunk(
  'course-ev-print',
  ({tarId, tarType}: {tarId: string; tarType: string}, thunkAPI) =>
    handleRequest(axios.get(`/api/timetable/course-ev-print/${tarId}/${tarType}`), thunkAPI)
)

export const EvReportExcel = createAsyncThunk('ev-report-excel', async (id: string) => {
  const response = await axios.get(`/api/timetable/ev-report-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Evaluation_Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const UpdateTimeSlot = createAsyncThunk('update-timeslot', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/timetable/update-timeslot', data), thunkAPI)
)

export const GetAyStudents = createAsyncThunk('update-timeslot', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/get-ay-stds/${id}`), thunkAPI)
)

export const GetAyProStds = createAsyncThunk('getAyProStds', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/timetable/get-pro-ay-stds', data), thunkAPI)
)

export const ProgramPrint = createAsyncThunk('program-print', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/program-print/${id}`), thunkAPI)
)

export const GetLessonTitles = createAsyncThunk('course-titles', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/course-lesson/list-course-titles/${id}`), thunkAPI)
)

export const createCourseTitle = createAsyncThunk('course-title-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post(`/api/course-lesson/store-course-title`, data), thunkAPI)
)

export const createCourseLes = createAsyncThunk('course-les-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post(`/api/course-lesson/store-course-material`, data), thunkAPI)
)

export const AyStudents = createAsyncThunk('course-les-create', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/timetable/ay-students/${id}`), thunkAPI)
)

export const AssignPeerEv = createAsyncThunk('assign-peer-evaluation', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/timetable/assign-peer-evaluation', data), thunkAPI)
)

export const getAttRepType = createAsyncThunk('att-report-type', (id: string, thunkAPI) =>
  handleRequest(axios.get(`/api/ac-reps/att-report-type/${id}`), thunkAPI)
)

export const AttReport = createAsyncThunk('att-report', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/ac-reps/att-report', data), thunkAPI)
)

export const AttReportPrint = createAsyncThunk('att-report-print', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/ac-reps/att-report-print', data), thunkAPI)
)

export const Years = createAsyncThunk('years', (_, thunkAPI) =>
  handleRequest(axios.get('/api/course/years'), thunkAPI)
)

export const AttReportPrintExcel = createAsyncThunk(
  'att-report-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/ac-reps/att-report-excel', formData, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'AttendanceReport.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const PrintCourseAtt = createAsyncThunk('att-print', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/ac-reps/att-print', data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ExportCourseAtt = createAsyncThunk('att-excel', async (data: {}) => {
  const response = await axios.post(`/api/ac-reps/att-excel`, data, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'AttendanceReport.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const getScoreRepType = createAsyncThunk('score-rep-type', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/ac-reps/score-report-type/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const scoreReport = createAsyncThunk('score-report', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/ac-reps/score-report', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ScoreReportPrint = createAsyncThunk(
  'score-report-print',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/ac-reps/score-report-print', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const scoreReportExcel = createAsyncThunk(
  'score-report-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/ac-reps/score-report-excel', formData, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'ScoreReport.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const PrintCourseScore = createAsyncThunk('score-print', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/ac-reps/score-print', data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ExportCourseScore = createAsyncThunk('score-excel', async (data: {}) => {
  const response = await axios.post(`/api/ac-reps/score-excel`, data, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'ScoreReport.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const planningAcademicYears = createAsyncThunk('plan-ac-years', async (_, thunkAPI) => {
  try {
    const res = await axios.get(`/api/timetable/plan-ac-years`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const aySemseters = createAsyncThunk('semesters', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/timetable/semesters/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ayPrograms = createAsyncThunk('programs', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/timetable/programs/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ayCourses = createAsyncThunk('courses', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/timetable/courses/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const transStudents = createAsyncThunk('transfer-students', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/timetable/transfer-students', data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getClasses = createAsyncThunk('classes', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/timetable/classes')
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const examClasses = createAsyncThunk('exam-classes', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/timetable/exam-classes')
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getExamPaperOptions = createAsyncThunk(
  'exampaper-options',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/ac-reps/exampaper-options/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const examPapers = createAsyncThunk('exam-papers', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/ac-reps/exam-papers', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const DldExamPapers = createAsyncThunk('dld-xm-paps', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/ac-reps/dld-xm-paps', data, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/zip',
      },
    })
    if (res.data.type === 'application/json') {
      const text = await res.data.text()
      const errorData = JSON.parse(text)
      return thunkAPI.rejectWithValue(errorData.message || 'Download failed')
    }

    return res.data
  } catch (error: any) {
    if (error.response?.data) {
      if (error.response.data instanceof Blob) {
        const text = await error.response.data.text()
        const errorData = JSON.parse(text)
        return thunkAPI.rejectWithValue(errorData.message || errorData.errors)
      }
      return thunkAPI.rejectWithValue(error.response.data.errors || error.response.data.message)
    }
    return thunkAPI.rejectWithValue(error.message)
  }
})

type AcademicsState = {
  record: any
  records: any
  errors: any
}

const initialState: AcademicsState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const academicSlice = createSlice({
  name: 'academic',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListCourse.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(listCourseLessons.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListPublicationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublicationCategory.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListPublicationField.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublicationField.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListPublication.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublication.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListVideoLibrary.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createVideoLibrary.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(emailToRelatedStudents.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListTimeTable.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = academicSlice.actions
export default academicSlice.reducer
